import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Card} from '../../models/models';
import {Translation} from '../../models/translation';
import {UserService} from '../../services/user.service';
import {TranslationService} from '../../services/translation.service';
import {ModuleService} from '../../services/module.service';
import {ChangePasswordService} from '../../services/change-password.service';
import {Location} from '@angular/common';
import Swal from 'sweetalert2';
import {sha256} from 'js-sha256';

@Component({
  selector: 'app-navigation',
  styleUrls: ['./navigation.component.css'],
  templateUrl: './navigation.component.html',
})
export class NavigationComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService,
    private changePasswordService: ChangePasswordService,
    private translationService: TranslationService,
    private moduleService: ModuleService,
    private location: Location
  ) { }

  public name: string;
  public isLoggedIn: boolean;
  public userHasStatusModule = false;
  public tempPw2: string;
  public tempPw3: string;
  public selectedLanguage: string;
  public translation: Translation = new Translation();
  public showBackButton = false;
  public sideNavShow = false;
  public moduleList: Card[];
  public noSpecialHoliday = true;
  public christmas = false;
  public firstOfAugust = false;
  public newYearsEve = false;
  public halloween = false;
  public easter = false;
  public stPatricksDay = false;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    if (localStorage.getItem('Translation') === 'undefined' || localStorage.getItem('Translation') === null) {
      localStorage.setItem('Language', 'DE');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(response => {
        if (response.Ok) {
          localStorage.setItem('Translation', JSON.stringify(response.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      this.translation = JSON.parse(localStorage.getItem('Translation'));
    }
    this.isLoggedIn = sessionStorage.getItem('Token') != null;
    if (!this.isLoggedIn) {
      this.name = this.translation.Login;
    } else {
      this.name = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    }

    this.selectedLanguage = localStorage.getItem('Language');
    if (this.router.url !== '/login' && this.router.url !== '/home' && this.router.url !== '/') {
      this.showBackButton = true;
    }

    if (+sessionStorage.getItem('UserId') !== 0) {
      this.moduleService.getModulesByUserId(+sessionStorage.getItem('UserId')).subscribe(response => {
        if (response.Ok) {
          const tempCards: Card[] = [];
          if (response.Obj.length !== 0) {
            for (const module of response.Obj) {
              const card = new Card();
              switch (module.ModuleId) {
                case 1: card.Title = this.translation.Transport; break;
                case 2: card.Title = this.translation.WheelNews; break;
                case 3: card.Title = this.translation.Cartec; break;
                case 4: card.Title = this.translation.AirportParking; break;
                case 5: card.Title = this.translation.StatusCheck; break;
                case 6: card.Title = this.translation.Administration; break;
              }
              card.ForwardLink = module.ForwardLink;
              tempCards.push(card);
            }
            this.moduleList = tempCards;
          } else {
            Swal.fire(this.translation.Error, this.translation.NoAssignedModulesMessage, 'error');
            sessionStorage.clear();
            this.router.navigate(['/login']).then(r => r);
          }
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    }

    if (sessionStorage.getItem('Modules') !== null) {
      this.userHasStatusModule = JSON.parse(sessionStorage.getItem('Modules')).findIndex(x => x.ModuleId === 80) !== -1;
    }

    this.CheckSpecialHolidayForLogo();
  }

  changePassword() {
    this.userService.getUserById(+sessionStorage.getItem('UserId')).subscribe(responseUser => {
      if (responseUser.Ok) {
        Swal.mixin({
          input: 'password',
          inputValidator: (value) => {
            if (responseUser.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
            return !value && this.translation.YouHaveToEnterAPassword;
          },
          confirmButtonColor: '#CC0000',
          allowOutsideClick: false,
          showCancelButton: true,
          showConfirmButton: true,
          reverseButtons: true,
          cancelButtonText: this.translation.Cancel,
          confirmButtonText: this.translation.Next + ' &rarr;',
          progressSteps: ['1', '2', '3']
        }).queue([
          {
            title: this.translation.PasswordChange,
            text: this.translation.OldPassword,
            inputValidator: (value) => {
              if (responseUser.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '0'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.NewPassword,
            inputValidator: (value) => {
              this.tempPw2 = value;
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '1'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.RepeatPassword,
            inputValidator: (value) => {
              this.tempPw3 = value;
              if (this.tempPw2 !== this.tempPw3) { return this.translation.RepeatPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToRepeatTheNewPassword;
            },
            currentProgressStep: '2'
          }
        ]).then((result: any) => {
          if (result.value) {
            this.changePasswordService.updatePasswordWithoutToken(responseUser.Obj.UserId, this.tempPw2).subscribe(response => {
              if (response.Ok) {
                if (response.Obj) {
                  Swal.fire({title: this.translation.PasswordChanged, icon: 'success', confirmButtonColor: '#CC0000'});
                }
              } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
              if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          }
        });
      } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
      if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  changeLanguage(language: string) {
    this.selectedLanguage = language;
    localStorage.setItem('Language', language);
    this.translationService.getTranslation(language).subscribe(responseTranslation => {
      if (responseTranslation.Ok) {
        localStorage.setItem('Translation', JSON.stringify(responseTranslation.Obj));
        if (sessionStorage.getItem('UserId') !== null) {
          this.userService.getUserById(+sessionStorage.getItem('UserId')).subscribe(responseUser => {
            if (responseUser.Ok) {
              this.userService.updateUserLanguage(responseUser.Obj.UserId, language).subscribe();
              window.location.reload();
            } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
            if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        } else {
          window.location.reload();
        }
      } else if (responseTranslation.Msg === 'Internal Server Error') { console.log(responseTranslation.Ex); }
      if (responseTranslation.Msg) { this.toast.fire({title: responseTranslation.Msg, icon: responseTranslation.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  logout() {
    const tempWnSpecial = sessionStorage.getItem('WheelnewsSpecial');
    sessionStorage.clear();
    this.name = this.translation.Login;
    if (tempWnSpecial != null) {
      this.router.navigate(['/' + tempWnSpecial + 'login']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  home() {
    if (this.router.url !== '/login' && this.router.url !== '/') {
      this.router.navigate(['/home']);
    }
  }

  goBack() {
    this.location.back();
  }

  openOrCloseMenu() {
    this.sideNavShow = !this.sideNavShow;
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }

  CheckSpecialHolidayForLogo() {
    const today = new Date();

    switch (today.getMonth()) {
      case 0:
        // Neujahr 27.12. - 01.01.
        if (today.getDate() === 1) {
          this.noSpecialHoliday = false;
          this.newYearsEve = true;
        }
        break;
      case 2:
        // St. Patricks Day
        if (today.getDate() === 17) {
          this.noSpecialHoliday = false;
          this.stPatricksDay = true;
          break;
        }
      // tslint:disable-next-line:no-switch-case-fall-through
      case 3:
        // Ostern
        const easter = this.GaussEaster(today.getFullYear());
        const easterRange = new Date(easter.getTime() - 240 * 60 * 60 * 1000);
        if (today >= easterRange && today <= easter) {
          this.noSpecialHoliday = false;
          this.easter = true;
        }
        break;
      case 7:
        // Schweizer Nationalfeiertag 01.08.
        if (today.getDate() === 1) {
          this.noSpecialHoliday = false;
          this.firstOfAugust = true;
        }
        break;
      case 9:
        // Halloween
        if (today.getDate() >= 20) {
          this.noSpecialHoliday = false;
          this.halloween = true;
        }
        break;
      case 11:
        // Weihnachtszeit 01.12. - 25.12.
        if (today.getDate() <= 26) {
          this.noSpecialHoliday = false;
          this.christmas = true;
        } else {
          // Neujahr 27.12. - 01.01.
          this.noSpecialHoliday = false;
          this.newYearsEve = true;
        }
        break;
    }
  }

  GaussEaster(Y: number) {
    const C = Math.floor(Y / 100);
    const N = Y - 19 * Math.floor(Y / 19);
    const K = Math.floor((C - 17) / 25);
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor((I / 30));
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    const L = I - J;
    const M = 3 + Math.floor((L + 40) / 44);
    const D = L + 28 - 31 * Math.floor(M / 4);

    return new Date(Y, M - 1, D);
  }
}
